module.exports = __webpack_public_path__ + "img/medal_2.1f0b9ce5.png";